module.exports = __webpack_public_path__ + "img/MpeV3B-5.21a8d02f.jpg";